import { useEffect, useState } from "react";
import {getTodayAttendance, checkInAttendance, checkOutAttendance} from "services/api/attendanceApi";
import {showSuccess, showError} from "utils/toast";



export default function TodayAttendanceCard() {
    const [attendance, setAttendance] = useState(null);
    const [loading, setLoading] = useState(false);

    const loadAttendance = async () => {
        try {

            const response = await getTodayAttendance();

            setAttendance(response?.data?.attendance || null);

        }
        catch (error) {

            showError(error.response?.data?.message || "Unable to load attendance");

        }

    };

    useEffect(() => {

        loadAttendance();

    }, []);

    const getLocation = () => {

        return new Promise((resolve) => {

                if (!navigator.geolocation) {

                    resolve({});

                    return;

                }

                navigator.geolocation.getCurrentPosition(

                    (position) => {

                        resolve({

                            latitude:
                                String(position.coords.latitude),

                            longitude:
                                String(position.coords.longitude)

                        });


                    },


                    () => {

                        resolve({});

                    }

                );


            }

        );


    };


    const handleCheckIn = async () => {


        try {


            setLoading(true);


            const location =
                await getLocation();



            const response =
                await checkInAttendance({

                    ...location,

                    address:
                        "Web Location"


                });



            setAttendance(
                response.data.attendance
            );



            showSuccess(
                "Checked in successfully"
            );



        }
        catch (error) {


            showError(
                error.response?.data?.message ||
                "Check-in failed"
            );


        }
        finally {

            setLoading(false);

        }


    };


    const handleCheckOut = async () => {


        try {


            setLoading(true);



            const location =
                await getLocation();



            const response =
                await checkOutAttendance({

                    ...location,

                    address:
                        "Web Location"

                });



            setAttendance(
                response.data.attendance
            );



            showSuccess(
                "Checked out successfully"
            );



        }
        catch (error) {


            showError(
                error.response?.data?.message ||
                "Check-out failed"
            );


        }
        finally {


            setLoading(false);


        }



    };


    const formatTime = (date) => {


        if (!date)
            return "-";


        return new Date(date)
            .toLocaleTimeString(
                [],
                {
                    hour: "2-digit",
                    minute: "2-digit"
                }
            );


    };


    const workingHours = () => {


        if (!attendance?.totalMinutes)
            return "-";


        const hours =
            Math.floor(
                attendance.totalMinutes / 60
            );


        const minutes =
            attendance.totalMinutes % 60;



        return `${hours}h ${minutes}m`;


    };


    return (


        <div
            className="
            rounded-xl
            bg-white
            p-5
            shadow
            dark:bg-navy-800
            "
        >


            <h3
                className="
                mb-4
                text-xl
                font-bold
                text-navy-700
                dark:text-white
                "
            >

                Today's Attendance

            </h3>

            <div className="mb-4">


                <p className="text-sm text-gray-500">

                    Status

                </p>


                <span
                    className="
                    rounded-full
                    bg-green-100
                    px-3
                    py-1
                    text-sm
                    font-semibold
                    text-green-700
                    "
                >

                    {
                        attendance?.status ||
                        "Not Checked In"
                    }

                </span>


            </div>

            {

                attendance?.checkInAt &&

                <div className="mb-3">

                    <p className="text-sm text-gray-500">

                        Check In

                    </p>


                    <p className="font-semibold">

                        {
                            formatTime(
                                attendance.checkInAt
                            )
                        }

                    </p>

                </div>

            }

            {

                attendance?.checkOutAt &&

                <div className="mb-3">


                    <p className="text-sm text-gray-500">

                        Check Out

                    </p>


                    <p className="font-semibold">

                        {
                            formatTime(
                                attendance.checkOutAt
                            )
                        }

                    </p>


                </div>

            }

            {

                attendance?.totalMinutes &&

                <div className="mb-3">


                    <p className="text-sm text-gray-500">

                        Working Hours

                    </p>


                    <p className="font-semibold">

                        {
                            workingHours()
                        }

                    </p>


                </div>


            }

            {

                !attendance &&

                <button

                    onClick={handleCheckIn}

                    disabled={loading}

                    className="
                        w-full
                        rounded-xl
                        bg-brand-500
                        py-3
                        text-white
                        "

                >

                    {
                        loading
                            ?
                            "Processing..."
                            :
                            "Check In"
                    }


                </button>


            }

            {

                attendance &&
                !attendance.checkOutAt &&


                <button

                    onClick={handleCheckOut}

                    disabled={loading}

                    className="
                    w-full
                    rounded-xl
                    bg-red-500
                    py-3
                    text-white
                    "

                >

                    {
                        loading
                            ?
                            "Processing..."
                            :
                            "Check Out"
                    }


                </button>


            }

        </div>

    );

}